// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ManagementDDL/styles.css
// module id = 2444
// module chunks = 193